import {
	NEW_VALUATION_ID,
	ValuationPathPart,
} from '@dealstack/frontend/app/pages/Valuations/shared/valuationRoutes';

export const getValuationIdFromPath = (pathname: string): string | undefined => {
	const pathParts = pathname.split('/');
	let pathValuationId: string | undefined;
	for (let i = 0; i + 1 < pathParts.length; i++) {
		if (pathParts[i] === ValuationPathPart.VALUATIONS) {
			if (pathParts[i + 1] && pathParts[i + 1] !== NEW_VALUATION_ID) {
				pathValuationId = pathParts[i + 1];
				break;
			}
			return undefined;
		}
	}
	return pathValuationId;
};

export const getSelectedEntityFromPath = (
	pathname: string,
	search: string
): { personId?: string; mipId?: string } => {
	const urlParams = new URLSearchParams(search);
	const personId = urlParams.get('personId') ?? undefined;
	const mipId = urlParams.get('mipId') ?? undefined;

	return { personId, mipId };
};
